export function parseCurrencyToNumber(currency: string) {
  return parseFloat(currency.replace(/[^0-9.]/g, ''));
}
